import PropTypes from 'prop-types'
// import menu from '../assets/menu.svg'
import BtnApply from '../components/btnApply'
import MenuItem from '../components/menuItem'
import { useEffect, useRef, useState } from 'react'
import { useInView } from 'framer-motion'
import MobileDrawer from '../components/mobileDrawer'
import { apis } from '../api/apiUrl'
const Drawer = ({ open, handleOpen }) => {
    const [data, setData] = useState([])
    // const menulists = [
    //     {
    //         title: "About Uniten",
    //         items: [
    //             {
    //                 name: "About UNITEN",
    //                 link:"/about"
    //             },
    //             {
    //                 name: "Colleges" ,
    //                 link:"/about?sideTab=8"
    //             },
    //             // {
    //             //     name: "Our Partners" ,
    //             //     link:"/our partners"
    //             // },
    //             {
    //                 name: "Our People",
    //                 link:"/our people"
    //             },
    //             {
    //                 name: "Our Alumni & Community",
    //                 link:"/our alumni"
    //             },
    //             {
    //                 name: "Contact Us",
    //                 link:"/contact us"
    //             },
    //         ]
    //     },
    //     {
    //         title: "education",
    //         items: [
    //             {
    //                 name: "Explore All Programs",
    //                 link:"/all programmes"
    //             },
    //             // {
    //             //     name: " Foundation"
    //             // },

    //             // {
    //             //     name: "Diploma"
    //             // },
    //             // {
    //             //     name: "Undergraduate"
    //             // },
    //             // {
    //             //     name: "Postgraduate"
    //             // },
    //             {
    //                 name: "Scholarships"
    //                 ,
    //                 link:"/scholarships"
    //             },
    //             {
    //                 name: "Admission",
    //                 link:"/admission"
    //             },
    //         ]
    //     },
    //     {
    //         title: "Explore",
    //         items: [
    //             {
    //                 name: "Staff",
    //                 link:"/staff hub"
    //             },
    //             {
    //                 name: "Student",
    //                 link:"/student hub"
    //             },
    //             {
    //                 name: "Campus Life",
    //                 link:"/campus life"
    //             },
    //             {
    //                 name: "Academic Calendar",
    //                 link:"/academic calendar"
    //             },
    //             {
    //                 name: "News & Events",
    //                 link:"/news & events"
    //             },
    //             {
    //                 name: "Research",
    //                 link:"/research"
    //             },
    //             {
    //                 name: "Training & Services",
    //                 link:"/training & services"
    //             },
    //             {
    //                 name: "Vacancies",
    //                 link:"/vacancies"
                    
    //             },
    //             // {
    //             //     name: "Course Generator",
    //             //     link:"/course generator"
    //             // },
    //             {
    //                 name: "TNB Official Website",
    //                 link:"https://www.tnb.com.my/"
    //             },
    //             {
    //                 name: "International Office",
    //                 link:"/international office"
    //             },
    //             {
    //                 name: "FAQ",
    //                 link:'/faq'
    //             },
    //         ]
    //     }
    //     ,
    //     {
    //         title: "Home",
    //         link:"/"
    //     }
    // ]
    useEffect(()=>{
        const fetchData = async () => {
            const res = await fetch(`${apis.umbraco_delivery_api}/menu`)
            const data = await res.json()
            console.log("This is menu data",data)
            const menu = data?.properties?.menuComponent?.items?.sort((a,b)=>{
                return a?.content?.properties?.numberOrdering - b?.content?.properties?.numberOrdering
            })?.map(item=>{
                item = item?.content?.properties
                return {
                    title: item?.title,
                    link: item?.title === "Home" ? "/" : item?.pagePath ? item?.pagePath[0]?.url : null,
                    items: item?.subMenus?.items?.sort((a,b)=>{
                        return a?.content?.properties?.numberOrdering - b?.content?.properties?.numberOrdering
                    })?.map(subMenu=>{
                        subMenu = subMenu?.content?.properties
                        return {
                            name: subMenu?.title,
                            link: subMenu?.pagePath ? subMenu?.pagePath[0]?.url : null
                        }

                    })
                }
            })
            console.log("This is menu",menu)
            setData(menu)
        }
        fetchData()
       

    },[])



    const menu = '/assets/menu.svg'


    const ref = useRef()
    const isInViewH1 = useInView(ref, { once: true });
    const [activeNavItem,setActiveNavItem] = useState(-1)
    if (typeof window !== 'undefined') {
        if (open) {
            document.body.style.overflow = "hidden";
            document.getElementsByClassName('z-30')[1]?.classList?.add("!z-20")
        } else {
            document.body.style.overflow = "unset";
            document.getElementsByClassName('z-30')[1]?.classList?.remove("!z-20")

        }
    }

    return (
        <>

            <div className={`absolute h-screen xl:h-[calc(100vh+100px)] drawer inset-0 w-full   overflow-hidden bg-cover text-gray-200 bg-center bg-no-repeat transition-all duration-300  ${open ? "translate-x-0 ease-in-opacity-100 " : "-translate-x-full ease-out opacity-0"} `} style={{ backgroundImage: `url('${menu}')` }}>

                <div className='relative w-full h-full flex flex-col lg:flex-row justify-between p-3 '>

                    <div

                        className={`flex   w-full flex-col items-start gap-3  `}>
                        <div className="flex w-full items-center justify-between ">

                            <button
                                ref={ref}
                                aria-label={open ? "close" : "open"}
                                style={{
                                    transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.1s"
                                }}
                                className={` text-slate-200  ${(open && isInViewH1) ? 'translate-x-5 ease-in opacity-100' : 'md:-translate-x-full md:ease-out md:opacity-0'}`}
                                onClick={() => handleOpen(false)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={50}
                                    height={50}
                                    fill="currentColor"
                                    className="bi font-bold"
                                    viewBox="0 0 16 16"
                                >

                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                </svg>
                            </button>
                            <div
                                ref={ref}
                                style={{
                                    transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
                                }}
                                className={` h-fit ${(open && isInViewH1) ? '-translate-x-5 ease-in opacity-100' : 'md:-translate-x-full md:ease-out md:opacity-0'}`}>
                                <BtnApply />
                            </div>
                        </div>
                        <ul
                            ref={ref}
                            style={{
                                transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.1s"
                            }}
                            onMouseEnter={()=>setActiveNavItem(-1)}
                            className={`hidden lg:flex flex-col  h-full  mt-6 w-[60%] 2xl:w-1/2 relative ${(open && isInViewH1) ? 'translate-x-5 ease-in opacity-100' : '-translate-x-full ease-out opacity-0'}`}>
                            {
                                data?.map((list, index) => (
                                    <MenuItem key={index} handleClose={()=>handleOpen(false)} list={list} handleItemHover={()=>setActiveNavItem(index)} activeNavItem={activeNavItem === index ? true : false} />
                                ))
                            }
                        </ul>
                        <div className='flex w-full h-screen flex-col lg:hidden'>
                            <MobileDrawer menulists={data} handleClose={()=>handleOpen(false)} />
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
Drawer.propTypes = {
    open: PropTypes.bool,
    handleOpen: PropTypes.func
}
export default Drawer